(function () {
  'use strict';

  // ── TRACKING MM-ANALYTICS ──────────────────────────────────────────
  function trackQuiz(event, question, answer, profile, product, variant, price) {
    try {
      fetch('https://mm-analytics.onrender.com/quiz-track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          secret: 'mm2026voyage',
          event: event,
          question: question || '',
          answer: answer || '',
          profile: profile || '',
          product: product || '',
          variant: variant || '',
          price: price || ''
        })
      });
    } catch(e) {}
  }
  // ───────────────────────────────────────────────────────────────────

  var SAISON_STEP = {
    id: 'saison',
    question: 'Pour quelle saison souhaitez-vous un parfum ?',
    options: [
      { value: 'Printemps', icon: '🌸', label: 'Printemps', desc: 'Fraîcheur et légèreté' },
      { value: 'Été', icon: '☀️', label: 'Été', desc: 'Fraîcheur et vitalité' },
      { value: 'Automne', icon: '🍂', label: 'Automne', desc: 'Chaleur et profondeur' },
      { value: 'Hiver', icon: '❄️', label: 'Hiver', desc: 'Enveloppant et intense' }
    ]
  };

  var OCCASION_STEP = {
    id: 'occasion',
    question: 'Pour quelle occasion ?',
    options: [
      { value: 'Quotidien', icon: '☕', label: 'Quotidien', desc: 'Au bureau, en balade' },
      { value: 'Soirée', icon: '🌙', label: 'Soirée', desc: 'Restaurant, sortie' },
      { value: 'Évènement spécial', icon: '✨', label: 'Évènement spécial', desc: 'Cérémonie, gala' }
    ]
  };

  var FAMILLE_STEP = {
    id: 'famille_olfactive',
    question: 'Quelle famille olfactive vous attire ?',
    options: [
      { value: 'Parfum Floral', icon: '🌹', label: 'Floral', desc: 'Fleurs, féminité, douceur' },
      { value: 'Parfum Boisé', icon: '🌲', label: 'Boisé', desc: 'Bois, ambre, nature' },
      { value: 'Parfum Oriental', icon: '🕌', label: 'Oriental', desc: 'Épices, résines, chaleur' },
      { value: 'Parfum Aromatique', icon: '🌿', label: 'Aromatique', desc: 'Herbes, fougère, fraîcheur' },
      { value: 'Parfum Hespéridé', icon: '🍋', label: 'Hespéridé', desc: 'Agrumes, légèreté, soleil' }
    ]
  };

  var NOTES_ORIENTAL_STEP = {
    id: 'notes',
    question: 'Quelles notes vous attirent le plus ?',
    multi: true,
    options: [
      { value: 'Vanille', icon: '🍦', label: 'Vanille', desc: 'Douceur crémeuse', searchTerms: ['vanille'] },
      { value: 'Ambre', icon: '💎', label: 'Ambre', desc: 'Chaleur résineuse', searchTerms: ['ambre'] },
      { value: 'Fève de Tonka', icon: '🌑', label: 'Fève de Tonka', desc: 'Sucrée et boisée', searchTerms: ['tonka'] },
      { value: 'Oud', icon: '🪵', label: 'Oud', desc: 'Mystérieux et profond', searchTerms: ['oud'] },
      { value: 'Notes Gourmandes', icon: '🍯', label: 'Notes Gourmandes', desc: 'Miel, pralin, caramel', searchTerms: ['pralin', 'miel', 'caramel', 'chocolat', 'nougat', 'rhum', 'gourmand'] },
      { value: 'Épices', icon: '🌶️', label: 'Épices', desc: 'Cannelle, safran, cardamome', searchTerms: ['cannelle', 'safran', 'cardamome', 'gingembre', 'épice', 'muscade', 'clou'] }
    ]
  };

  var NOTES_FLORAL_STEP = {
    id: 'notes',
    question: 'Quelles notes vous attirent le plus ?',
    multi: true,
    options: [
      { value: 'Rose', icon: '🌹', label: 'Rose', desc: 'Florale et romantique', searchTerms: ['rose'] },
      { value: 'Musc', icon: '🤍', label: 'Musc', desc: 'Doux et enveloppant', searchTerms: ['musc'] },
      { value: 'Vanille', icon: '🍦', label: 'Vanille', desc: 'Crémeuse et douce', searchTerms: ['vanille'] },
      { value: 'Jasmin', icon: '🌼', label: 'Jasmin', desc: 'Floral et sensuel', searchTerms: ['jasmin'] },
      { value: "Fleur d'oranger", icon: '🍊', label: "Fleur d'oranger", desc: 'Fraîche et lumineuse', searchTerms: ["fleur d'oranger", 'néroli', 'oranger'] }
    ]
  };

  var INTENSITE_STEP = {
    id: 'intensite',
    question: 'Quelle intensité préférez-vous ?',
    options: [
      { value: 'Moyenne', icon: '🌫️', label: 'Moyenne', desc: 'Subtile et légère' },
      { value: 'Forte', icon: '💨', label: 'Forte', desc: 'Présente et affirmée' }
    ]
  };

  var products = [];
  var filtered = [];
  var answers = {};
  var currentStepIndex = -1;
  var dataLoaded = false;
  var overlay, modal;

  function getSteps() {
    var steps = [SAISON_STEP, OCCASION_STEP, FAMILLE_STEP];
    var famille = answers['famille_olfactive'];
    if (famille === 'Parfum Oriental') steps.push(NOTES_ORIENTAL_STEP);
    else if (famille === 'Parfum Floral') steps.push(NOTES_FLORAL_STEP);
    steps.push(INTENSITE_STEP);
    return steps;
  }

  function getNoteConfig(val) {
    var famille = answers['famille_olfactive'];
    var noteStep = famille === 'Parfum Oriental' ? NOTES_ORIENTAL_STEP : NOTES_FLORAL_STEP;
    for (var i = 0; i < noteStep.options.length; i++) {
      if (noteStep.options[i].value === val) return noteStep.options[i];
    }
    return null;
  }

  function init() {
    overlay = document.getElementById('quiz-overlay');
    modal = document.getElementById('quiz-modal');
    if (!overlay) return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quiz-open]');
      if (trigger) { e.preventDefault(); openQuiz(); }
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuiz();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuiz();
    });

    modal.querySelectorAll('.quiz-close, .quiz-close-step').forEach(function (btn) {
      btn.addEventListener('click', closeQuiz);
    });

    var btnStart = modal.querySelector('.quiz-btn-start');
    if (btnStart) btnStart.addEventListener('click', startQuiz);

    var btnRetry = modal.querySelector('.quiz-btn-retry');
    if (btnRetry) btnRetry.addEventListener('click', function () {
      answers = {};
      filtered = products.slice();
      showScreen('intro');
    });
  }

  function openQuiz() {
    overlay.style.display = 'flex';
    requestAnimationFrame(function() {
      overlay.classList.add('quiz-open');
    });
    document.body.style.overflow = 'hidden';
    showScreen('intro');
    if (!dataLoaded) loadData();
    trackQuiz('open', '', '', '', '', '', '');
  }

  function closeQuiz() {
    overlay.classList.remove('quiz-open');
    document.body.style.overflow = '';
    setTimeout(function() { overlay.style.display = 'none'; }, 320);
  }

  function loadData() {
    var url = window.quizProductsUrl;
    if (!url) return;
    var cached = null;
    try { cached = sessionStorage.getItem('quizProducts_v20'); } catch(e) {}
    if (cached) {
      try { products = JSON.parse(cached); filtered = products.slice(); dataLoaded = true; return; } catch(e) {}
    }
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        products = data; filtered = data.slice(); dataLoaded = true;
        try { sessionStorage.setItem('quizProducts_v20', JSON.stringify(data)); } catch(e) {}
      })
      .catch(function (e) { console.error('Quiz: load error', e); });
  }

  function showScreen(name) {
    modal.querySelectorAll('.quiz-screen').forEach(function (s) { s.classList.remove('active'); });
    var screen = modal.querySelector('.quiz-screen-' + name);
    if (screen) { screen.classList.add('active'); modal.scrollTop = 0; }
  }

  function matchProduct(p, testAnswers) {
    for (var key in testAnswers) {
      var val = testAnswers[key];
      if (key === 'saison') {
        var pVals = p.saison || [];
        if (pVals.indexOf(val) === -1 && pVals.indexOf('Toute saison') === -1) return false;
      } else if (key === 'notes') {
        var noteVals = Array.isArray(val) ? val : [val];
        var nc = (p.notes_combined || '').toLowerCase();
        var matchesAny = noteVals.some(function(noteVal) {
          var cfg = getNoteConfig(noteVal);
          var terms = cfg ? cfg.searchTerms : [noteVal.toLowerCase()];
          return terms.some(function(t) { return nc.indexOf(t) !== -1; });
        });
        if (!matchesAny) return false;
      } else {
        var pArr = p[key] || [];
        if (pArr.indexOf(val) === -1) return false;
      }
    }
    return true;
  }

  function applyFilters() {
    filtered = products.filter(function (p) { return matchProduct(p, answers); });
  }

  function countWith(key, val) {
    var testAnswers = Object.assign({}, answers);
    testAnswers[key] = val;
    return products.filter(function (p) { return matchProduct(p, testAnswers); }).length;
  }

  function countWithNotes(selectedVals) {
    var testAnswers = Object.assign({}, answers);
    testAnswers['notes'] = selectedVals;
    return products.filter(function (p) { return matchProduct(p, testAnswers); }).length;
  }

  function startQuiz() {
    answers = {};
    filtered = products.slice();
    goToStep(0);
  }

  function goToStep(i) {
    currentStepIndex = i;
    var steps = getSteps();
    if (i >= steps.length) {
      renderResults();
      showScreen('results');
      return;
    }
    renderStep(i, steps);
    showScreen('step');
  }

  function renderStep(i, steps) {
    var step = steps[i];
    var isMulti = !!step.multi;
    var el = modal.querySelector('.quiz-screen-step');
    var total = steps.length;

    var bar = el.querySelector('.quiz-progress-bar');
    var segs = '';
    for (var s = 0; s < total; s++) {
      segs += '<div class="quiz-progress-seg' + (s < i ? ' done' : '') + '"></div>';
    }
    bar.innerHTML = segs;

    el.querySelector('.quiz-step-count').textContent = 'Question ' + (i + 1) + ' / ' + total;
    el.querySelector('.quiz-step-question').textContent = step.question;

    var remaining = el.querySelector('.quiz-step-remaining');
    remaining.textContent = filtered.length + ' parfum' + (filtered.length > 1 ? 's' : '') + ' correspond' + (filtered.length > 1 ? 'ent' : '') + ' à votre sélection';

    var curAnswer = answers[step.id];

    var optGrid = el.querySelector('.quiz-options');
    optGrid.innerHTML = step.options.map(function (opt) {
      var selected;
      if (isMulti) {
        selected = Array.isArray(curAnswer) && curAnswer.indexOf(opt.value) !== -1 ? ' selected' : '';
      } else {
        selected = curAnswer === opt.value ? ' selected' : '';
      }
      return '<button class="quiz-option' + selected + '" data-value="' + opt.value + '">'
        + '<span class="quiz-option-icon">' + opt.icon + '</span>'
        + '<span class="quiz-option-label">' + opt.label + '</span>'
        + (opt.desc ? '<span class="quiz-option-desc">' + opt.desc + '</span>' : '')
        + '</button>';
    }).join('');

    var existingHint = el.querySelector('.quiz-multi-hint');
    if (isMulti) {
      if (!existingHint) {
        var hintEl = document.createElement('p');
        hintEl.className = 'quiz-multi-hint';
        hintEl.style.cssText = 'font-size:12px;color:#b05a1a;margin:0 0 0;padding:0 36px;font-style:italic;';
        hintEl.textContent = 'Vous pouvez sélectionner plusieurs notes';
        el.querySelector('.quiz-step-header').appendChild(hintEl);
      }
    } else {
      if (existingHint) existingHint.remove();
    }

    var nextBtn = el.querySelector('.quiz-btn-next');
    if (isMulti) {
      nextBtn.classList.toggle('enabled', Array.isArray(curAnswer) && curAnswer.length > 0);
    } else {
      nextBtn.classList.toggle('enabled', !!curAnswer);
    }

    optGrid.querySelectorAll('.quiz-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isMulti) {
          btn.classList.toggle('selected');
          var selectedVals = Array.prototype.slice.call(optGrid.querySelectorAll('.quiz-option.selected'))
            .map(function(b) { return b.dataset.value; });
          nextBtn.classList.toggle('enabled', selectedVals.length > 0);
          var count = selectedVals.length > 0 ? countWithNotes(selectedVals) : filtered.length;
          remaining.textContent = count + ' parfum' + (count > 1 ? 's' : '') + ' correspond' + (count > 1 ? 'ent' : '') + ' à votre sélection';
        } else {
          optGrid.querySelectorAll('.quiz-option').forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          nextBtn.classList.add('enabled');
          var count = countWith(step.id, btn.dataset.value);
          remaining.textContent = count + ' parfum' + (count > 1 ? 's' : '') + ' correspond' + (count > 1 ? 'ent' : '') + ' à votre sélection';
        }
      });
    });

    nextBtn.onclick = function () {
      if (isMulti) {
        var selectedVals = Array.prototype.slice.call(optGrid.querySelectorAll('.quiz-option.selected'))
          .map(function(b) { return b.dataset.value; });
        if (selectedVals.length === 0) return;
        answers[step.id] = selectedVals;
        trackQuiz('answer', step.question, selectedVals.join(', '), '', '', '', '');
      } else {
        var selected = optGrid.querySelector('.quiz-option.selected');
        if (!selected) return;
        if (step.id === 'famille_olfactive' && answers['famille_olfactive'] !== selected.dataset.value) {
          delete answers['notes'];
        }
        answers[step.id] = selected.dataset.value;
        trackQuiz('answer', step.question, selected.dataset.value, '', '', '', '');
      }
      applyFilters();
      goToStep(i + 1);
    };

    var backBtn = el.querySelector('.quiz-btn-back');
    if (i === 0) {
      backBtn.style.visibility = 'hidden';
    } else {
      backBtn.style.visibility = 'visible';
      backBtn.onclick = function () {
        delete answers[step.id];
        applyFilters();
        goToStep(i - 1);
      };
    }
  }

  function scoreProduct(p) {
    var score = 100;
    var s = p.saison || [];
    if (s.indexOf('Toute saison') !== -1) score -= 12;
    else if (s.length >= 3) score -= 6;
    var occ = p.occasion || [];
    if (occ.length === 3) score -= 8;
    else if (occ.length === 2) score -= 4;
    if (answers.notes) {
      var noteVals = Array.isArray(answers.notes) ? answers.notes : [answers.notes];
      var nc = (p.notes_combined || '').toLowerCase();
      var totalTerms = 0, foundTerms = 0;
      noteVals.forEach(function(noteVal) {
        var cfg = getNoteConfig(noteVal);
        if (cfg) {
          totalTerms += cfg.searchTerms.length;
          foundTerms += cfg.searchTerms.filter(function(t) { return nc.indexOf(t) !== -1; }).length;
        }
      });
      if (foundTerms === 0) score -= 15;
      else if (foundTerms < Math.ceil(totalTerms / 2)) score -= 6;
    }
    return Math.max(65, Math.min(100, score));
  }

  var variantCache = {};

  var STEP_LABELS = {
    saison: 'Saison', occasion: 'Occasion',
    famille_olfactive: 'Famille', notes: 'Note', intensite: 'Intensité'
  };

  function firstNote(str) {
    return str ? str.split(',')[0].trim() : '';
  }

  function buildCard(p) {
    var pct = scoreProduct(p);
    var notesHtml = '';
    var nt = firstNote(p.notes_tete), nc = firstNote(p.notes_coeur), nf = firstNote(p.notes_fond);
    if (nt) notesHtml += '<div><strong>Tête ·</strong> ' + nt + '</div>';
    if (nc) notesHtml += '<div><strong>Cœur ·</strong> ' + nc + '</div>';
    if (nf) notesHtml += '<div><strong>Fond ·</strong> ' + nf + '</div>';
    var imgTag = p.image
      ? '<img class="quiz-product-img" src="' + p.image + '" alt="" loading="lazy">'
      : '<div class="quiz-product-img" style="background:#f0ede8;aspect-ratio:1"></div>';
    return '<div class="quiz-product-card" data-handle="' + p.handle + '">'
      + '<a href="' + p.url + '" class="quiz-product-link" onclick="window.closeQuizFromLink()">' + imgTag + '</a>'
      + '<div class="quiz-product-body">'
      + '<div class="quiz-match-pct">🎯 Recommandé à ' + pct + '%</div>'
      + '<div class="quiz-product-title">' + p.title + '</div>'
      + '<div class="quiz-product-price">À partir de ' + p.price + '</div>'
      + (notesHtml ? '<div class="quiz-product-notes">' + notesHtml + '</div>' : '')
      + '<a href="' + p.url + '" class="quiz-btn-voir quiz-product-link" onclick="window.closeQuizFromLink()">Voir le produit</a>'
      + '<div class="quiz-variant-section">'
      + '<button class="quiz-btn-options" data-handle="' + p.handle + '">Choisir une option ▾</button>'
      + '<select class="quiz-variant-select"><option value="">Sélectionner une option...</option></select>'
      + '<button class="quiz-btn-cart" data-variant="">Ajouter au panier</button>'
      + '<div class="quiz-cart-msg"></div>'
      + '</div>'
      + '</div></div>';
  }

  function attachCardEvents(grid) {
    grid.addEventListener('click', function(e) {
      var optBtn = e.target.closest('.quiz-btn-options');
      if (optBtn) { e.preventDefault(); handleOptionsClick(optBtn); }
      var cartBtn = e.target.closest('.quiz-btn-cart.enabled');
      if (cartBtn) { e.preventDefault(); handleCartClick(cartBtn); }
      var productLink = e.target.closest('.quiz-product-link');
      if (productLink) {
        var card = productLink.closest('.quiz-product-card');
        var titleEl = card ? card.querySelector('.quiz-product-title') : null;
        var title = titleEl ? titleEl.textContent : (card ? card.dataset.handle : '');
        trackQuiz('click', '', '', '', title, '', '');
      }
    });
    grid.addEventListener('change', function(e) {
      var sel = e.target.closest('.quiz-variant-select');
      if (sel) handleVariantChange(sel);
    });
  }

  function renderResults() {
    var el = modal.querySelector('.quiz-screen-results');
    var grid = el.querySelector('.quiz-results-grid');
    var sub = el.querySelector('.quiz-results-sub');
    var summary = el.querySelector('.quiz-results-summary');
    var footer = el.querySelector('.quiz-results-footer');
    var showMoreBtn = footer.querySelector('.quiz-btn-show-more');

    sub.textContent = filtered.length + ' parfum' + (filtered.length > 1 ? 's correspondent' : ' correspond') + ' à votre profil olfactif';
    var profileLabel = Object.values(answers).flat().join(' | ');
    trackQuiz('results', '', '', profileLabel, '', '', '');

    summary.innerHTML = Object.keys(answers).map(function(k) {
      var v = answers[k];
      if (Array.isArray(v)) {
        return v.map(function(item) {
          return '<span class="quiz-badge" title="' + (STEP_LABELS[k] || k) + '">' + item.replace('Parfum ', '') + '</span>';
        }).join('');
      }
      return '<span class="quiz-badge" title="' + (STEP_LABELS[k] || k) + '">' + v.replace('Parfum ', '') + '</span>';
    }).join('');

    if (filtered.length === 0) {
      grid.innerHTML = '<div class="quiz-no-results">'
        + '<div class="quiz-no-results-icon">🔍</div>'
        + '<div class="quiz-no-results-title">Aucun parfum exact trouvé</div>'
        + '<p>Essayez de modifier vos critères pour découvrir plus de parfums.</p>'
        + '</div>';
      showMoreBtn.style.display = 'none';
      return;
    }

    var sorted = filtered.slice().sort(function(a, b) {
      return scoreProduct(b) - scoreProduct(a);
    });
    var first = sorted.slice(0, 8);
    var rest = sorted.slice(8);

    grid.innerHTML = first.map(buildCard).join('');
    attachCardEvents(grid);

    if (rest.length > 0) {
      showMoreBtn.textContent = 'Afficher les ' + rest.length + ' autres parfums';
      showMoreBtn.style.display = '';
      showMoreBtn.onclick = function() {
        grid.insertAdjacentHTML('beforeend', rest.map(buildCard).join(''));
        showMoreBtn.style.display = 'none';
      };
    } else {
      showMoreBtn.style.display = 'none';
    }
  }

  function handleOptionsClick(btn) {
    var handle = btn.dataset.handle;
    var card = btn.closest('.quiz-product-card');
    var sel = card.querySelector('.quiz-variant-select');

    if (sel.style.display === 'block') { sel.style.display = 'none'; return; }
    if (sel.options.length > 1) { sel.style.display = 'block'; return; }

    btn.textContent = 'Chargement...';
    btn.disabled = true;

    var cached = variantCache[handle];
    if (cached) {
      populateVariants(sel, cached);
      btn.textContent = 'Choisir une option ▾';
      btn.disabled = false;
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        variantCache[handle] = data.product.variants;
        populateVariants(sel, data.product.variants);
        btn.textContent = 'Choisir une option ▾';
        btn.disabled = false;
      })
      .catch(function() {
        btn.textContent = 'Choisir une option ▾';
        btn.disabled = false;
      });
  }

  function populateVariants(sel, variants) {
    sel.innerHTML = '<option value="">Sélectionner une option...</option>'
      + variants.map(function(v) {
          return '<option value="' + v.id + '">' + v.title + '</option>';
        }).join('');
    sel.style.display = 'block';
  }

  function handleVariantChange(sel) {
    var card = sel.closest('.quiz-product-card');
    var cartBtn = card.querySelector('.quiz-btn-cart');
    if (sel.value) {
      cartBtn.classList.add('enabled');
      cartBtn.dataset.variant = sel.value;
    } else {
      cartBtn.classList.remove('enabled');
      cartBtn.dataset.variant = '';
    }
  }

  function handleCartClick(btn) {
    var variantId = btn.dataset.variant;
    if (!variantId) return;
    var card = btn.closest('.quiz-product-card');
    var msg = card.querySelector('.quiz-cart-msg');
    var orig = btn.textContent;
    btn.textContent = 'Ajout...';
    btn.classList.remove('enabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) throw data;
        return data;
      });
    })
    .then(function() {
      btn.textContent = '✓ Ajouté !';
      btn.classList.add('enabled');
      msg.textContent = 'Produit ajouté au panier';
      msg.className = 'quiz-cart-msg success';
      var atcCard = btn.closest('.quiz-product-card');
      var atcName = atcCard ? (atcCard.getAttribute('data-product-title') || '') : '';
      trackQuiz('atc', '', '', '', atcName, String(variantId), '');
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var counter = document.querySelector('.cart-count-bubble, [data-cart-count], .js-cart-count');
        if (counter) counter.textContent = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      });
      setTimeout(function() {
        btn.textContent = orig;
        msg.textContent = '';
        msg.className = 'quiz-cart-msg';
      }, 3000);
    })
    .catch(function(err) {
      btn.textContent = orig;
      btn.classList.add('enabled');
      var errMsg = (err && err.description) ? err.description : 'Rupture de stock pour cette option.';
      msg.textContent = errMsg;
      msg.className = 'quiz-cart-msg error';
    });
  }

  window.closeQuizFromLink = function () { closeQuiz(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
